import React from 'react'
import { NavLink } from 'react-router-dom'
import './BB8Breadcrumbs.scss'
import BB8MainPage from './BB8MainPage'

interface IBB8BreadcrumbsProps {
  routes: Array<{ path: string; title: string }>
}

const BB8Breadcrumbs: React.SFC<IBB8BreadcrumbsProps> = props => (
  <BB8MainPage.Padded>
    <ol className={'bb8-breadcrumbs-wrapper'}>
      <li>
        <NavLink to="/">Home</NavLink>
      </li>
      {props.routes && props.routes.length
        ? props.routes.map((route, i) => (
            <li key={route.path}>
              {i === props.routes.length - 1 ? (
                <span>{route.title}</span>
              ) : (
                <NavLink to={route.path}>{route.title}</NavLink>
              )}
            </li>
          ))
        : undefined}
    </ol>
  </BB8MainPage.Padded>
)

export default BB8Breadcrumbs
